import {
  VISIBLE_LIVE_CASINO_FILTER,
  VISIBLE_LOBDY_GAME_FILTER,
} from '~/configs'
import type { RoutesEnum } from '~/enums'

export function useFilterGame() {
  const route = useRoute()

  const isLobbyGameFilter = computed(() => {
    const path = route.path as RoutesEnum
    return VISIBLE_LOBDY_GAME_FILTER.some((filterPath) =>
      path.startsWith(filterPath),
    )
  })
  const isLiveCasinoFilter = computed(() => {
    const path = route.path as RoutesEnum
    return VISIBLE_LIVE_CASINO_FILTER.some((filterPath) =>
      path.startsWith(filterPath),
    )
  })

  return {
    isLobbyGameFilter,
    isLiveCasinoFilter,
  }
}
